import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = { class: "flex align-items-center gap-1" };
const _hoisted_3 = ["src"];
import _ from "lodash";
import AuPagination from "@/components/extended/AuPagination.vue";
import i18n from "@/localization/localization";
import ProgressLoader from "@/loaders/progress-bar";
import UTable from "@/components/uikit/uComponents/UTable.vue";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Stock',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const dataTrades = ref([]);
        const page = ref(1);
        const itemsPerPage = ref(30);
        const tradesTotalItems = ref(0);
        const loading = ref(true);
        // Computed колонки для UTable
        const tableColumns = computed(() => {
            return [
                {
                    property: "token",
                    header: i18n.global.t("briefcase.firstColumn"),
                    align: "start"
                },
                {
                    property: "availableBalance",
                    header: i18n.global.t("briefcase.availableBalanceColumn"),
                    align: "start"
                },
                {
                    property: "mnemonic",
                    header: i18n.global.t("briefcase.mnemonicColumn"),
                    align: "start"
                },
                {
                    property: "inOrderBalance",
                    header: i18n.global.t("briefcase.inOrderBalanceColumn"),
                    align: "start"
                },
                {
                    property: "totalBalance",
                    header: i18n.global.t("briefcase.totalBalanceColumn"),
                    align: "start"
                },
                {
                    property: "actions",
                    header: i18n.global.t("briefcase.action"),
                    align: "center",
                    type: "menu",
                    menuFunction: getStockMenuItems
                }
            ];
        });
        // Форматирование данных для таблицы
        const itemsTrade = computed(() => {
            return _.map(dataTrades.value, (item, index) => {
                // Создаем уникальный ID
                const itemId = item.tokenId !== -1 ? `stock-${item.tokenId}` : `stock-${index}-${Date.now()}`;
                return {
                    id: itemId,
                    token: {
                        mnemonic: item.tokenId === -1 ? _.toUpper(item?.token) : item?.nameEng,
                        icon: item?.icon || "/svg/companies/s_logo.svg"
                    },
                    availableBalance: item?.availableBalance || 0,
                    mnemonic: item?.token || "",
                    inOrderBalance: item?.inOrderBalance || 0,
                    totalBalance: item?.totalBalance || 0,
                    // Данные для контекстного меню
                    actionData: {
                        tokenId: item.tokenId,
                        index: index,
                        isKnownToken: item.tokenId !== -1
                    }
                };
            });
        });
        // Функция для получения информации о токене
        const getTokenInfo = async (token) => {
            let icon = "/svg/companies/s_logo.svg";
            let tokenId = -1;
            let nameEng = token;
            if (token) {
                const buf = _.find(store.getters.tokens, item => _.toUpper(item.mnemonicEng) === _.toUpper(token));
                icon = buf?.logoMain ?? icon;
                tokenId = buf?.id ?? tokenId;
                nameEng = buf?.nameEng ?? nameEng;
            }
            return { tokenId, icon, nameEng };
        };
        // Получение торговых балансов
        const getTradeBalances = async () => {
            loading.value = true;
            try {
                const resp = await store.dispatch("getTradeBalance", {
                    page: page.value,
                    itemsPerPage: itemsPerPage.value
                });
                dataTrades.value = resp.data;
                tradesTotalItems.value = resp.totalItems;
                // Загружаем информацию о токенах параллельно
                const promises = resp.data.map(async (item) => {
                    const token = await getTokenInfo(item?.token ?? "");
                    item.tokenId = token.tokenId;
                    item.icon = token.icon;
                    item.nameEng = token.nameEng;
                });
                await Promise.all(promises);
            }
            catch (e) {
                console.error(e);
            }
            finally {
                loading.value = false;
            }
        };
        // Функция для генерации пунктов меню
        function getStockMenuItems(actionData) {
            const items = [];
            // Кнопка открытия торговой платформы
            items.push({
                label: i18n.global.t("briefcase.openStock"),
                command: () => {
                    goToTradingPlatform();
                }
            });
            // Кнопка депозита (только для известных токенов)
            if (actionData.isKnownToken) {
                items.push({
                    label: i18n.global.t("briefcase.depositStock"),
                    command: () => {
                        goToDeposit(actionData.tokenId);
                    }
                });
            }
            // Кнопка вывода (только для известных токенов)
            if (actionData.isKnownToken) {
                items.push({
                    label: i18n.global.t("briefcase.withdrawStock"),
                    command: () => {
                        goToWithdraw(actionData.tokenId);
                    }
                });
            }
            return [
                {
                    items: items
                }
            ];
        }
        // Обработчики навигации
        const goToDeposit = (tokenId) => {
            router.push({ name: "stock deposit", params: { id: tokenId } });
        };
        const goToWithdraw = (tokenId) => {
            router.push({ name: "stock withdraw", params: { id: tokenId } });
        };
        const systemSettings = store.getters.apiSystemSettings;
        const goToTradingPlatform = () => {
            window.open(systemSettings?.exchangeUrl, "_blank");
        };
        // Пагинация
        const pageTradeChanges = async (actualPage) => {
            page.value = actualPage;
            await getTradeBalances();
        };
        onMounted(async () => {
            await getTradeBalances();
        });
        return (_ctx, _cache) => {
            return (loading.value)
                ? (_openBlock(), _createBlock(_unref(ProgressLoader), {
                    key: 0,
                    mode: "indeterminate",
                    color: "#5AC396",
                    size: "150px"
                }))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(UTable, {
                        items: itemsTrade.value,
                        columns: tableColumns.value
                    }, {
                        token: _withCtx(({ value }) => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("img", {
                                    class: "token-logo",
                                    src: value.icon,
                                    alt: "icon"
                                }, null, 8, _hoisted_3),
                                _createTextVNode(" " + _toDisplayString(value.mnemonic), 1)
                            ])
                        ]),
                        availableBalance: _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString(value), 1)
                        ]),
                        mnemonic: _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString(value), 1)
                        ]),
                        inOrderBalance: _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString(value), 1)
                        ]),
                        totalBalance: _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString(value), 1)
                        ]),
                        actions: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
                        _: 1
                    }, 8, ["items", "columns"]),
                    (tradesTotalItems.value > itemsPerPage.value)
                        ? (_openBlock(), _createBlock(AuPagination, {
                            key: 0,
                            "total-items": tradesTotalItems.value,
                            onPageChanged: pageTradeChanges
                        }, null, 8, ["total-items"]))
                        : _createCommentVNode("", true)
                ]));
        };
    }
});
